import { css } from '@emotion/react';

const scrollCss = ({ theme }: { theme: Theme }) => css`
  &::-webkit-scrollbar {
    width: 12px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  &:focus,
  &:hover,
  &:active {
    &::-webkit-scrollbar-thumb {
      border: 4px solid transparent;
      border-radius: 12px;
      background-color: ${theme.color.surface10};
      background-clip: content-box;
    }
  }
  scrollbar-color: ${theme.color.surface10} transparent;
  scrollbar-width: thin;
`;

export default scrollCss;
